import AuthOneLogin from './AuthOneLogin';

export default AuthOneLogin;



// WEBPACK FOOTER //
// ./src/views/authOneLogin/index.js